/**
 * Detects whether or not the site is being viewed on a mobile device
 * (supported: iOS and Android)
 */
export function isMobileDevice(): boolean {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Check for iOS devices
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

  // Check for Android devices
  const isAndroid = /android/i.test(userAgent);

  return isIOS || isAndroid;
}